"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
const React = __importStar(require("react"));
const piral_core_1 = require("piral-core");
const components_1 = require("@smapiot/components");
const HeaderLinks_1 = __importDefault(require("./HeaderLinks"));
const logo_svg_1 = __importDefault(require("../assets/logo.svg"));
const Header = () => {
    const user = (0, piral_core_1.useGlobalState)((s) => s.user);
    return (React.createElement(React.Fragment, null,
        React.createElement(components_1.PageHeader, { home: "/", logo: React.createElement("img", { src: logo_svg_1.default, alt: "Piral Cloud Partner" }) },
            React.createElement(components_1.HeaderMenu, null,
                React.createElement(HeaderLinks_1.default, null),
                React.createElement(components_1.HeaderLink, { exact: true, to: "/logout" },
                    React.createElement("i", { className: "fas fa-sign-out-alt", title: "Logout" }),
                    React.createElement("span", { className: "hamburger-only" }, " Logout")))),
        React.createElement("div", { className: "container topbar" },
            React.createElement(components_1.AccountInfo, { userName: user.name, title: user.id }))));
};
exports.Header = Header;
